export default __webpack_public_path__ + "static/media/clipboard-active.e1d99ca8.svg";